export default __webpack_public_path__ + "5607fdaeae3b6473a009502457a773c3.webp";